<template>
  <header class="flex justify-around fundo-principal w-full">
    <div class="flex flex-row flex-wrap justify-center py-1">
      <img src="@/assets/img/semed_logo.png" alt="" class="text-black w-full h-14 mx-4 my-2 object-contain">
    </div>
    <div class="flex flex-row flex-wrap justify-center py-1">
      <img src="@/assets/img/logo_prodam/1.svg" alt="" class="text-black w-full h-16 mx-4 my-2 object-contain">
    </div>
  </header>
</template>

<script>
export default {
  name: "Header"
}
</script>

<style scoped>

</style>
